import { render, staticRenderFns } from "./ServiceTutorEdit.vue?vue&type=template&id=3f076a18&scoped=true&"
import script from "./ServiceTutorEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceTutorEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTutorEdit.vue?vue&type=style&index=0&id=3f076a18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f076a18",
  null
  
)

export default component.exports